// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import { useRenewSubscription } from 'hooks/subscriptions/mutations';
import { useSubscription } from 'hooks/subscriptions/queries';
import { formatSubscriptionPrice } from '../../../utils/subscriptionUtils';
import AccountSingleButton from '../AccountSingleButton';

const BillingModalRenew = ({ onSuccess }) => {
  const { data: subscription } = useSubscription();
  const renewSubscriptionMutation = useRenewSubscription();
  const plan = subscription?.plan || {};

  const uncancelSubscription = (e) => {
    if (subscription && subscription.id) {
      renewSubscriptionMutation.mutate(subscription.id, {
        onSuccess: () => {
          // Call the onSuccess callback if provided
          if (onSuccess) {
            onSuccess();
          }
        }
      });
    }
  };

  return (
      <div>
        <AccountSingleButton
          error={renewSubscriptionMutation.error && {
            error: true,
            message: renewSubscriptionMutation.error?.response?.data?.error || 'Something went wrong, please refresh and try again.'
          }}
          onClick={uncancelSubscription}
          loading={renewSubscriptionMutation.isPending}
          header="Renew Subscription"
          button="Confirm Subscription Renewal"
          disclaimer={`By renewing your subscription, you agree to automatically
                      be charged each ${plan?.interval || 'month'} until you cancel.`}
          body={<p>Renew your subscription for {formatSubscriptionPrice(subscription)} a {plan?.interval || 'month'}.</p>}
        />
      </div>
  );
};

export default BillingModalRenew;
